import React from "react";
import { getSortingClass, getTableStyles } from "../../utils/envtable";
import PaginationButtons from "../../layouts/PaginationButtons";
import { convertToUTCFormat } from "../../utils/format";

const EnvConfigTable = ({
  ENVDATA,
  total,
  sortingColumns,
  handleSorting,
  envConfigCheckboxes,
  handleEnvConfigTableCheckboxChange,
  page,
  pageSelected,
  prevPage,
  nextPage,
  openAddEnvConfigModal,
}) => {
  const openEditEnvConfigModal = (e, values = {}) => {
    openAddEnvConfigModal(e, values);
  };

  return (
    <div role="tabpanel" className="tab-pane fade in active" id="cases">
      <div className="table-responsive">
        <div id="case_wrapper" className="dataTables_wrapper no-footer">
          <table
            id="env_config_list"
            className="rcTableview display table table-bordered table-hover dataTable no-footer"
            cellSpacing="0"
            width="100%"
          >
            <style>{getTableStyles()}</style>
            <thead className="env-config-heading-style">
              <tr role="row">
                <th
                  className={`sorting${getSortingClass(
                    sortingColumns,
                    "id"
                  )} env-config-id`}
                  rowSpan="1"
                  colSpan="1"
                  onClick={() => handleSorting("id")}
                >
                  ID
                </th>
                <th
                  className="sorting_disabled env-config-env-type"
                  rowSpan="1"
                  colSpan="1"
                >
                  Env Type
                </th>
                <th
                  className={`sorting${getSortingClass(
                    sortingColumns,
                    "key"
                  )} env-config-key`}
                  rowSpan="1"
                  colSpan="1"
                  onClick={() => handleSorting("key")}
                >
                  Key
                </th>
                <th
                  className={`sorting${getSortingClass(
                    sortingColumns,
                    "value"
                  )} env-config-value`}
                  rowSpan="1"
                  colSpan="1"
                  onClick={() => handleSorting("value")}
                >
                  Value
                </th>
                <th
                  className={`sorting${getSortingClass(
                    sortingColumns,
                    "status"
                  )} env-config-status`}
                  rowSpan="1"
                  colSpan="1"
                  onClick={() => handleSorting("status")}
                >
                  Status
                </th>
                <th
                  className={`sorting${getSortingClass(
                    sortingColumns,
                    "added_on"
                  )} env-config-added-on`}
                  rowSpan="1"
                  colSpan="1"
                  onClick={() => handleSorting("added_on")}
                >
                  Added On
                </th>
                <th
                  className={`sorting${getSortingClass(
                    sortingColumns,
                    "updated_on"
                  )} env-config-updated-on`}
                  rowSpan="1"
                  colSpan="1"
                  onClick={() => handleSorting("updated_on")}
                >
                  Updated On
                </th>
                <th
                  className="sorting_disabled env-config-action"
                  rowSpan="1"
                  colSpan="1"
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="env-config-body-style">
              {ENVDATA.map((envVal, idx) => {
                const {
                  id,
                  env_type_id,
                  env_type,
                  param_key,
                  param_value,
                  status,
                  date_added,
                  date_updated,
                } = envVal;
                return (
                  <tr
                    role="row"
                    className={`${
                      idx % 2 === 1 ? "even" : "odd"
                    } withheld-table-row`}
                    key={idx}
                  >
                    <td>{id}</td>
                    <td>{env_type}</td>
                    <td className="env-config-value-style">{param_key}</td>
                    <td className="env-config-value-style">{param_value}</td>
                    <td>{status}</td>
                    <td>
                      {date_added
                        ? convertToUTCFormat(date_added, "dd-MM-yyyy kk:mm:ss")
                        : ""}
                    </td>
                    <td>
                      {date_updated
                        ? convertToUTCFormat(
                            date_updated,
                            "dd-MM-yyyy kk:mm:ss"
                          )
                        : ""}
                    </td>
                    <td>
                      <div className="env-table-action-cell">
                        <button
                          type="button"
                          className="btn edit-env_config-btn"
                          title="Edit"
                          onClick={(e) =>
                            openEditEnvConfigModal(e, {
                              key: param_key,
                              value: param_value,
                              status,
                              env_type: env_type_id,
                              id,
                            })
                          }
                        >
                          <span className="fa fa-pencil mrg-R5"></span> Edit
                        </button>
                        <label htmlFor="env_config_rows_1">
                          <input
                            type="checkbox"
                            id="env_config_rows_1"
                            style={{ display: "block", marginLeft: "10px" }}
                            className="pull-right"
                            checked={envConfigCheckboxes[id] || false}
                            onChange={(e) =>
                              handleEnvConfigTableCheckboxChange(e, id, {
                                id,
                                env_id: env_type_id,
                                param_key,
                              })
                            }
                            onClick={() => {}}
                          />
                        </label>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <PaginationButtons
            page={page}
            total={total}
            prevPage={prevPage}
            nextPage={nextPage}
            pageSelected={pageSelected}
          />
        </div>
      </div>
    </div>
  );
};

export default EnvConfigTable;
